export default __webpack_public_path__ + "static/snippet-vk-5755579eadb3bee4866f7643b6786b3b.png";